import { useEffect, useRef } from "react";
import { Card } from "@/shared/components/ui/card";

const MEDIA_CLASS = "h-[45px] w-14 shrink-0 object-contain";

export function UploadPreview({
  file,
  percent,
}: {
  file: File;
  percent: number | null;
}) {
  const image = useRef<HTMLImageElement>(null);
  const video = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const url = URL.createObjectURL(file);
    const element = image.current ?? video.current;
    if (element) element.src = url;
    return () => URL.revokeObjectURL(url);
  }, [file]);
  return (
    <Card
      className="flex-row items-center gap-2 rounded-lg p-1.5 text-xs shadow-none"
      role="status"
    >
      {file.type.startsWith("image/") ? (
        <img className={MEDIA_CLASS} ref={image} alt={file.name} />
      ) : (
        <video
          className={MEDIA_CLASS}
          playsInline
          ref={video}
          muted
          preload="metadata"
          aria-label={file.name}
        />
      )}
      <span className="min-w-0 flex-1 wrap-anywhere">
        {file.name}
        <small className="block text-muted-foreground">
          {percent === 100
            ? "Upload received · processing…"
            : percent === null
              ? "Uploading…"
              : `Uploading ${percent}%`}
        </small>
        <progress
          className="mt-1 block h-[5px] w-full appearance-none overflow-hidden rounded-full bg-muted accent-gold [&::-moz-progress-bar]:bg-gold [&::-webkit-progress-bar]:bg-muted [&::-webkit-progress-value]:bg-gold"
          aria-label={`Uploading ${file.name}`}
          value={percent ?? undefined}
          max={100}
        />
      </span>
    </Card>
  );
}
